import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {
  Container,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Grid,
  OutlinedInput,
  TextField,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import classNames from "classnames";

import Styles from "../../assests/styles/CalenderStyles";
import AutoComplete1 from "../../Utils/Select";
import * as DateUtil from "../../Utils/DatePicker";
import { handleDateChange } from "../../Utils/DateFormatter";
import DataTable from "../../Utils/GenericUI/DataTable";
import { EVENTS_POPUP_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import {
  AddProspectAssignAgent,
  ContactMethod,
  NoteInputComponent,
  RadioButtonsComponent,
} from "./EventComponents";
import moment from "moment";
import {
  getAgentList,
  loadDemographics,
  setCampaignProspectStateParams,
  loadprospectOnagent,
  setStateParamsCalendar,
} from "../../Redux/Actions/webAppActions";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { VERDA_CONSTS } from "../../Utils/StaticData/Constant";
const dummyData = [
  {
    attendees: 1,
    prospectName: "name",
    contactPreference: "90",
    phone: "+91",
    email: "g@gmail.com",
    others: "oth",
  },
  {
    attendees: 2,
    prospectName: "second",
    contactPreference: "90",
    phone: "+91",
    email: "g@gmail.com",
    others: "oth",
  },
  {
    attendees: 3,
    prospectName: "third",
    contactPreference: "90",
    phone: "+91",
    email: "g@gmail.com",
    others: "oth",
  },
  {
    attendees: 4,
    prospectName: "fourth",
    contactPreference: "90",
    phone: "+91",
    email: "g@gmail.com",
    others: "oth",
  },
  {
    attendees: 5,
    prospectName: "fifth",
    contactPreference: "90",
    phone: "+91",
    email: "g@gmail.com",
    others: "oth",
  },
];
const INITIAL_STATE = {
  eventId: "",
  eventType: "Sales",
  eventAddress: "",
  start: "",
  end: "",
  agentName: "",
  maxAttendees: "",
  appointmentConfimInd: "N",
  soaInd: "N",
  note: "",
  phone: "",
  email: "",
  agentEmail: "",
  prospectName: {},
  prospectData: [],
  prospectDataSales: [],
  prospectDataAppointmentsFollowup: [],
};
const DATE_INT = {
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
};
const Event = (props) => {
  const { classes } = props;
  //const [eventType, setEventType] = useState("salesEvent");
  const [eventData, setEventData] = useState(props.eveData);
  const [date, setDate] = useState(DATE_INT);
  const [prospectListBasedOnagent, setprospectListonagent] = useState([]);
  const [propspectList, setProspectList] = useState([]);
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [vertical] = useState("top");
  const [horizontal] = useState("center");
  const [snackBarSeverty, setsnackBarSeverty] = useState("");
  const [snackBarMsg, setsnackBarMsg] = useState("");

  const {
    eventId,
    eventType,
    eventAddress,
    start,
    end,
    agentName,
    maxAttendees,
    appointmentConfimInd,
    soaInd,
    note,
    phone,
    email,
    agentEmail,
    prospectName,
    prospectData,
    prospectDataSales,
    prospectDataAppointmentsFollowup,
  } = eventData;
  const { startDate, startTime, endDate, endTime } = date;

  const formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString?.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  const handleDates = (fieldId, dateqnid) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      e.preventDefault();
      setDates(fieldId, e.target.value);
      DateUtil.getDatePicker("#" + fieldId).datepicker("refresh");
    });
  };

  // const handleDate = async (event) => {
  //   let name = event.target.name;
  //   let value = event.target.value;

  //   value = handleDateChange(value);

  //   setDate((p) => ({
  //     ...p,
  //     [name]: moment(value).format("YYYY-MM-DD"),
  //   }));
  // };

  const setDates = async (fieldId, value) => {
    setDate((p) => ({
      ...p,
      [fieldId]: moment(value).format("YYYY-MM-DD"),
    }));
  };
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setsnackBarOpen(false);
  };
  const handleChange = (event) => {
    event.preventDefault();
    let value = event.target ? event.target.value : event.value;
    let name = event.target ? event.target.name : event.name;
    if (name === "eventType") {
      setprospectListonagent([]);
      setEventData({
        ...INITIAL_STATE,
        eventType: value,
      });
    }
    if (name === "phone") {
      value = formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name === "maxAttendees" && value < 1) {
      value = "";
    }
    setEventData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdown = (name) => async (event) => {
    if (eventType === "Prospect" || eventType === "Follow-Up") {
      if (name === "prospectName") {
        let selectedprospectData = propspectList.filter(
          (prospectname) => prospectname.value === event?.value
        );

        let selectedassignedTo = props?.prospectagentList.filter(
          (agent) =>
            agent?.label?.trim() == selectedprospectData[0]?.assignedTo?.trim()
        );
        await setEventData((i) => ({
          ...i,
          agentName: {
            agentId: selectedassignedTo[0]?.value,
            label: selectedassignedTo[0]?.label,
            value: selectedassignedTo[0]?.emailId,
          },
        }));
        await setEventData((prev) => ({
          ...prev,
          // prospectName: [],
          prospectDataAppointmentsFollowup: [
            {
              leadIdNbr: event?.value,
              label: event?.label,
              value: event?.value,
              agentId: event?.agentId,
            },
          ],
        }));
        updatingContactInfo()
        return;
      }
    }
    if (eventType === "Sales" && name === "agentName" && event?.agentId != "") {
      await props?.loadprospectOnagent({
        agentId: event?.agentId,
        userRole: event?.userRole,
      });
    }
    await setEventData((prev) => ({
      ...prev,
      [name]: {
        label: event?.label,
        value: event?.value,
        agentId: event?.agentId,
      },
    }));

    // props.loadDemographics({leadIdNbr:eventData?.prospectName?.value});
  };
  const updatingContactInfo = () =>{
    if (
      props?.prospectDemograpics &&
      Object.keys(props?.prospectDemograpics).length > 0
    ) {
      let phoneprospect =
        props?.prospectcontactPreference === "H"
          ? props?.prospectHomePhone
          : props?.prospectcontactPreference === "C"
          ? props?.prospectCellPhone
          : props?.prospectHomePhone
          ? props?.prospectHomePhone
          : props?.prospectCellPhone;
      let emailprospect = props?.prospectEmail;
  
      setEventData((prev) => ({
        ...prev,
        phone: phoneprospect,
        email: emailprospect,
      }));
    }
  }
  const handleRadioChanges = (name, value) => {
    setEventData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      //(eventData?.eventType === "Prospect"|| eventData?.eventType==="Follow-Up") &&
      eventData?.eventType &&
      eventData?.prospectData[0]?.leadIdNbr
    ) {
      if (eventData?.eventType === "Sales") {
        setEventData((prev) => ({
          ...prev,
          prospectDataSales: prospectData,
          prospectDataAppointmentsFollowup: [],
          prospectData: [],
        }));
      }
      if (
        eventData?.eventType === "Prospect" ||
        eventData?.eventType === "Follow-Up"
      ) {
        setEventData((prev) => ({
          ...prev,
          prospectDataAppointmentsFollowup: prospectData,
          prospectDataSales: [],
          prospectData: [],
        }));
      }
    }
  }, [
    eventData?.prospectData?.length > 0 &&
      eventData?.prospectData[0]?.leadIdNbr,
  ]);
  useEffect(() => {
    if (
      eventData?.eventType &&
      eventData?.prospectDataAppointmentsFollowup &&
      eventData?.prospectDataAppointmentsFollowup[0]?.leadIdNbr
    ) {
      const loadDemo = async () => {
        await props.loadDemographics({
          leadIdNbr: eventData?.prospectDataAppointmentsFollowup[0]?.leadIdNbr,
        });
      };
      loadDemo();
    }
  }, [
    eventData?.prospectDataAppointmentsFollowup?.length > 0 &&
      eventData?.prospectDataAppointmentsFollowup[0]?.leadIdNbr,
  ]);
  useEffect(() => {
    updatingContactInfo()
  }, [props?.prospectleadIdNbr]);
  useEffect(() => {
    const getAgentsList = async () => {
      if (
        props?.prospectagentList?.length === 1 ||
        props?.prospectagentList === undefined
      ) {
        await props.getAgentList(props?.loginData.customerId);
      }
    };
    let startDate1, startTime1, endDate1, endTime1;
    if (isEmpty(eventId)) {
      setEventData({
        ...INITIAL_STATE,
        eventType: !props.isSuperUser ? "Prospect" : INITIAL_STATE.eventType,
      });
      const { startStr, endStr } = props.info;
      startDate1 = startStr.split("T")[0];
      startTime1 = startStr.split("T")[1];
      endDate1 = endStr.split("T")[0];
      endTime1 = endStr.split("T")[1];
    } else {
      startDate1 = start.split("T")[0];
      startTime1 = start.split("T")[1];
      endDate1 = end.split("T")[0];
      endTime1 = end.split("T")[1];
    }
    setEventData((prev) => ({
      ...prev,
      phone: formatPhoneNumber(prev.phone),
    }));
    setDate({
      startDate: startDate1,
      startTime: startTime1,
      endDate: endDate1,
      endTime: endTime1,
    });
    let list = [];
    props.prospectList &&
      props.prospectList.forEach((i) =>
        list.push({
          label: i.firstName + " " + i.lastName,
          value: i.leadIdNbr,
          assignedTo: i.assignedTo,
        })
      );
    setProspectList(list);
    props.setCalander();
    getAgentsList();
    setprospectListonagent([]);
    props.setStateParamsCalendar("prospectListOnAgent", []);
    return () => {};
  }, []);

  useEffect(() => {
    const { agentEmailId } = props.loginData;
    let obj;
    if (props.prospectagentList) {
      if (props.isSuperUser) {
        obj = props.prospectagentList.filter(
          (i) => i.emailId?.toUpperCase() === agentEmail?.toUpperCase()
        );
      } else {
        obj = props.prospectagentList.filter(
          (i) => i.emailId?.toUpperCase() === agentEmailId?.toUpperCase()
        );
      }
      if (!isEmpty(obj)) {
        if (eventType === "Sales") {
          const loadprospect = async () => {
            await props?.loadprospectOnagent({
              agentId: obj[0].value,
              userRole: obj[0].userRole,
            });
          };
          loadprospect();
        }
        setEventData((i) => ({
          ...i,
          agentName: { label: obj[0].label, value: obj[0].emailId },
        }));
      }
    }
  }, [props.prospectagentList]);
  useEffect(() => {
    setEventData((prev) => ({
      ...prev,
      prospectName: {},
    }));
    let prospectListNew = [];
    if (props?.prospectListOnAgent?.length > 0) {
      props.prospectListOnAgent &&
        props.prospectListOnAgent.forEach((i) =>
          prospectListNew.push({
            label: i.firstName + " " + i.lastName,
            value: i.leadIdNbr,
            assignedTo: i.assignedTo,
          })
        );
    }
    setprospectListonagent(prospectListNew);
  }, [props?.prospectListOnAgent]);
  // useEffect(()=>{
  //   if(prospectDataSales===undefined){
  //     setEventData(
  //       {
  //         ...eventData,
  //         ["prospectDataSales"]:[]
  //       })
  //   }
  // },[prospectDataSales])
  const handleSchedule = async () => {
    if (
      startDate <= endDate
      // &&
      // startTime<endTime
    ) {
      let time = {};
      Object.defineProperty(time, "startTime", {
        value: startTime,
        writable: true,
      });
      Object.defineProperty(time, "endTime", {
        value: endTime,
        writable: true,
      });
      let payload = {
        ...eventData,
        prospectData:
          eventData?.eventType === "Sales"
            ? prospectDataSales
              ? prospectDataSales
              : []
            : prospectDataAppointmentsFollowup,
        prospectName: eventData?.eventType === "Sales" ? prospectName : {},
        start: `${startDate}T${moment(time.startTime, "HH:mm").format(
          "HH:mm:ss"
        )}`,
        end: `${endDate}T${moment(time.endTime, "HH:mm").format("HH:mm:ss")}`,
        agentName: agentName.label,
        agentEmail: agentName.value,
        eventId: isEmpty(eventData.eventId) ? "" : eventData.eventId,
        customerId: props.loginData.customerId,
        agentId:
          !props.isSuperUser === true
            ? props.prospectagentList?.find(
                (data) =>
                  data?.label?.toUpperCase() === agentName?.label?.toUpperCase()
              ).value
            : agentName.agentId
            ? agentName.agentId
            : eventData?.agentId,
        phone: eventData?.phone
          ?.replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", ""),
      };

      delete payload.prospectDataSales;
      delete payload.prospectDataAppointmentsFollowup;

      //console.log("clspayload",payload)

      await props.saveEvents(payload);
      props.setChange(new Date());
      await props.close();
      await props?.setCampaignProspectStateParams("demographicsData", {});
    } else {
      setsnackBarOpen(true);
      setsnackBarMsg("End Date cannot be lesser than Start Date");
      setsnackBarSeverty("error");
    }
  };
  const handleTime = (e) => {
    let { name, value } = e.target;
    setDate((p) => ({
      ...p,
      [name]: value,
    }));
  };

  const handleProspect = () => {
    if (maxAttendees?.length === 0) {
      setsnackBarOpen(true);
      setsnackBarMsg("Please enter the maximum attendees limit ");
      setsnackBarSeverty("error");
      return;
    }
    let obj = props.prospectList.filter(
      (i) => i.leadIdNbr === prospectName.value
    )[0];
    let newObj = Object.keys(obj)
      .filter((key) => key != "SOA" && key != "Enroll")
      .reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
    // console.log("ad-",props.prospectList,prospectName,obj,newObj,
    // prospectDataSales,prospectDataSales??[].length < maxAttendees)
    let selectedprospectLeadId = newObj?.leadIdNbr;
    let sameProspectSelected = (prospectDataSales ?? []).filter(
      (row) => row.leadIdNbr === selectedprospectLeadId
    );
    if (sameProspectSelected?.length > 0) {
      setsnackBarOpen(true);
      setsnackBarMsg("This prospect is already added");
      setsnackBarSeverty("error");
    }
    if ((prospectDataSales ?? []).length >= maxAttendees) {
      setsnackBarOpen(true);
      setsnackBarMsg("Maximum attendees reached.");
      setsnackBarSeverty("error");
    }
    if (
      (prospectDataSales ?? []).length < maxAttendees &&
      sameProspectSelected?.length === 0
    ) {
      setEventData((i) => ({
        ...i,
        prospectDataSales: [...(prospectDataSales ?? []), newObj],
      }));
    }
  };

  let disableFlag =
    // isEmpty(eventAddress) && isEmpty(agentName) && isEmpty(maxAttendees)
    //   ? true
    //   : false;
    eventType === "Sales"
      ? isEmpty(eventAddress) ||
        isEmpty(agentName.value ?? "") ||
        isEmpty(startTime) ||
        isEmpty(endTime) ||
        isEmpty(maxAttendees)
      : // ||eventData?.prospectDataSales?.length===0
        isEmpty(eventAddress) ||
        isEmpty(agentName.value ?? "") ||
        isEmpty(startTime) ||
        isEmpty(endTime) ||
        eventData?.prospectDataAppointmentsFollowup?.length === 0;

  let disableAgent =
    !isEmpty(eventId) && !props.isSuperUser && eventType === "Sales"
      ? true
      : false;
  return (
    <Container maxWidth="md" className={classes.eventMainContainer}>
      {/* {console.log("clstime",startDate, startTime, endDate, endTime,startDate<=endDate,startTime<endTime)} */}
      <div className={classes.popupCalenderHeader}>
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={handleSnackClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <header>Events/Meeting Type:</header>
        <button
          type="button"
          className="close"
          onClick={() => {
            props.close();
            props.setCampaignProspectStateParams("demographicsData", {});
          }}
        >
          &times;
        </button>
      </div>
      <div style={{ height: "2rem" }} />
      <Box>
        <div className="d-flex">
          <FormControl
            component="fieldset"
            className={classes.radioButtonContainer}
          >
            <RadioGroup
              aria-label="Calender"
              name="eventType"
              value={eventType}
              onChange={handleChange}
              row
            >
              <FormControlLabel
                value="Sales"
                control={
                  <Radio color="primary" disabled={!props.isSuperUser} />
                }
                label="Sales Event"
                disabled={!props.isSuperUser}
              />
              <FormControlLabel
                value="Prospect"
                control={<Radio color="primary" />}
                label="Prospect Appointments"
                // disabled={disableAgent}
              />
              <FormControlLabel
                value="Follow-Up"
                control={<Radio color="primary" />}
                label="Follow Up"
                // disabled={disableAgent}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </Box>
      <div>
        <Grid
          container
          spacing={2}
          className={eventType === "Sales" && classes.topContainer}
        >
          <Grid item xs={12} className="justify-content-end d-flex">
            <button
              disabled={disableFlag || disableAgent}
              onClick={() => handleSchedule()}
              className={classNames(
                classes.buttonActive,
                "btn mb-2 ml-2 d-flex align-items-center"
              )}
            >
              <p className="mb-0 mr-1">Schedule</p>
              <SendIcon color="white" fontSize="small" />
            </button>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {(eventType === "Prospect" || eventType === "Follow-Up") && (
                <AddProspectAssignAgent
                  value1={props.prospectagentList?.find(
                    (data) => data?.label === agentName?.label
                  )}
                  value2={maxAttendees}
                  onChange={handleChange}
                  options={props.prospectagentList ?? []}
                  handleDropdown={handleDropdown}
                  eventType={eventType}
                  propspectList={propspectList}
                  propectName={propspectList.filter(
                    (prospectname) =>
                      prospectname.value ===
                      eventData?.prospectDataAppointmentsFollowup[0]?.leadIdNbr
                  )}
                  agentDisable={!props.isSuperUser}
                  customerId={props.customerId}
                />
              )}
              {eventType === "Sales" && (
                <Grid
                  item
                  xs={12}
                  direction="row"
                  className={`d-flex ${!props.isSuperUser && "disable-form"}`}
                >
                  <TextField
                    name="eventAddress"
                    value={eventAddress}
                    size="small"
                    fullWidth
                    onChange={handleChange}
                    label="Address"
                    variant="outlined"
                    inputProps={{
                      maxLength: 50,
                      autoComplete: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "both",
                      "aria-haspopup": "false",
                    }}
                    error={!eventAddress}
                  />
                </Grid>
              )}

              {(eventType === "Prospect" || eventType === "Follow-Up") && (
                <ContactMethod
                  phone={phone}
                  email={email}
                  onChange={handleChange}
                  // formatPhoneNumber={formatPhoneNumber}
                />
              )}
              <Grid item xs={12} className={classes.scheduleDates}>
                <div className={classes.datesContainer}>
                  <p>Start time</p>
                  <OutlinedInput
                    // onChange={() => handleDate()}
                    onClick={(e) => handleDates("startDate")}
                    name="startDate"
                    id="startDate"
                    placeholder="MM/DD/YYYY"
                    endAdornment={<EventOutlinedIcon />}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    value={startDate}
                    inputProps={{ className: "scrollfix" }}
                    disabled={eventType === "Sales" && !props.isSuperUser}
                  />
                  <div className="col-lg-3 col-md-4 col-sm-8">
                    <TextField
                      value={startTime}
                      size="small"
                      variant="outlined"
                      type="time"
                      name="startTime"
                      onChange={handleTime}
                      disabled={eventType === "Sales" && !props.isSuperUser}
                      error={!startTime}
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                    />
                  </div>
                </div>
                <div className={classes.datesContainer}>
                  <p>End time</p>
                  <OutlinedInput
                    // onChange={() => handleDate()}
                    onClick={(e) => handleDates("endDate")}
                    name="endDate"
                    id="endDate"
                    placeholder="MM/DD/YYYY"
                    endAdornment={<EventOutlinedIcon />}
                    value={endDate}
                    inputProps={{ className: "scrollfix" }}
                    disabled={eventType === "Sales" && !props.isSuperUser}
                  />
                  <div className="col-lg-3 col-md-4 col-sm-8">
                    <TextField
                      value={endTime}
                      size="small"
                      variant="outlined"
                      disabled={eventType === "Sales" && !props.isSuperUser}
                      type="time"
                      name="endTime"
                      onChange={handleTime}
                      error={!endTime}
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                    />
                  </div>
                </div>
              </Grid>
              {(eventType === "Prospect" || eventType === "Follow-Up") && (
                <Grid item xs={12} direction="row" className="d-flex">
                  <TextField
                    name="eventAddress"
                    value={eventAddress}
                    size="small"
                    fullWidth
                    onChange={handleChange}
                    label="Address"
                    variant="outlined"
                    error={eventAddress === ""}
                    inputProps={{
                      maxLength: 50,
                      autoComplete: "off",
                      spellcheck: "false",
                      "aria-autocomplete": "both",
                      "aria-haspopup": "false",
                    }}
                  />
                </Grid>
              )}
              {eventType === "Sales" && (
                <AddProspectAssignAgent
                  value1={agentName}
                  value2={maxAttendees}
                  onChange={handleChange}
                  options={props.prospectagentList ?? []}
                  handleDropdown={handleDropdown}
                  eventType={eventType}
                  propspectList={propspectList}
                  propectName={prospectName}
                  agentDisable={!props.isSuperUser}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div
        className={classNames(classes.bottomContainer, "mt-8")}
        style={{ marginTop: "8px" }}
      >
        {eventType === "Sales" && (
          <div className={`mt-8 ${!props.isSuperUser && "disable-form"}`}>
            <div className="row">
              <div className="col-xs-12 col-md-12 col-lg-12 d-flex align-items-center">
                {props.customerId !== VERDA_CONSTS.ID && (
                  <RadioButtonsComponent
                    label={"Send Appointment Confirmation"}
                    value={appointmentConfimInd}
                    setValue={(value) =>
                      handleRadioChanges("appointmentConfimInd", value)
                    }
                    classes={classes}
                  />
                )}
                <>
                  <span className="label-container flex-grow-1 text-left">
                    <label className="labelcampaign" for="campaignMedia">
                      Add Prospect
                    </label>
                    <br />
                    <AutoComplete1
                      name="prospectName"
                      size="small"
                      variant="outlined"
                      handleChange={handleDropdown("prospectName")}
                      //error={prospectDataSales?.length===0
                      // }
                      options={prospectListBasedOnagent?.map((data) => ({
                        label: data.label,
                        value: data.value,
                      }))}
                      value={
                        prospectName
                          ? prospectName
                          : { label: "---Select---", value: "" }
                      }
                      // margin="20px auto"
                      width="100%"
                      fontSize="1rem"
                      show={true}
                      height="1rem"
                      dashboard="eventCalender"
                      fullWidth
                    />
                  </span>
                </>
                <button
                  disabled={isEmpty(prospectName) || disableAgent}
                  onClick={handleProspect}
                  className={classNames(
                    classes.buttonActive,
                    "btn mb-2 ml-2 d-flex align-items-center"
                  )}
                >
                  <p className="mb-0 mr-1">Add Prospect</p>
                </button>
              </div>
            </div>
            {console.log("prospectDataSales", prospectDataSales)}
            <DataTable
              // width="91%"
              width="100%"
              padding="4px 20px 4px 4px"
              dashboard="prospectManagement"
              data={prospectDataSales ? prospectDataSales : []}
              header={header}
              //exportAsExcel={true}
              rowsPerPage={5}
              rowsPerPageOptions={[3, 5, 8]}
              index={0}
              handleChangeRowsPerPage={() => {}}
              sortable={true}
              //searchable={true}
              clicked={() => {}}
              setClick={(x) => {}}
              isRowDeleteNeeded={VERDA_CONSTS.ID !== props.customerId}
              deleteRow={(e) =>
                setEventData({
                  ...eventData,
                  ["prospectDataSales"]: prospectDataSales.filter(
                    (p) => p.leadIdNbr !== e
                  ),
                })
              }
            />
          </div>
        )}
        {eventType === "Prospect" && props.customerId !== VERDA_CONSTS.ID && (
          <>
            <div className="row">
              <div className="col-xs-12 col-md-12 col-lg-12">
                <RadioButtonsComponent
                  label={"Send Appointment Confirmation"}
                  value={appointmentConfimInd}
                  setValue={(value) =>
                    handleRadioChanges("appointmentConfimInd", value)
                  }
                  classes={classes}
                />
              </div>
            </div>
          </>
        )}
        {eventType !== "Sales" && (
          <>
            <div className="row">
              <div className="col-xs-12 col-md-12 col-lg-12">
                <RadioButtonsComponent
                  label={"SOA Completed?"}
                  value={soaInd}
                  setValue={(value) => handleRadioChanges("soaInd", value)}
                  classes={classes}
                />
              </div>
            </div>
          </>
        )}
        {eventType !== "Sales" && (
          <>
            <div className="row">
              <div className="col-xs-12 col-md-12 col-lg-12">
                <NoteInputComponent
                  value={note}
                  handleChange={(e) => handleChange(e)}
                  classes={classes}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </Container>
  );
};

const mapDispatchToProps = {
  getAgentList,
  loadDemographics,
  setCampaignProspectStateParams,
  loadprospectOnagent,
  setStateParamsCalendar,
};
const mapStateToProps = (state) => {
  return {
    loginData: state.login,
    //prospectagentList: state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    prospectEmail: state.campaignProspect?.demographicsData?.emailAddress,
    prospectHomePhone: state.campaignProspect?.demographicsData?.homePhone,
    prospectCellPhone: state.campaignProspect?.demographicsData?.cellPhone,
    prospectcontactPreference:
      state.campaignProspect?.demographicsData?.contactPreference,
    prospectDemograpics: state.campaignProspect?.demographicsData,
    prospectleadIdNbr: state.campaignProspect?.demographicsData?.leadIdNbr,
    customerId: state.login.customerId,
    prospectListOnAgent: state.calendar.prospectListOnAgent,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(Event));
